import React from 'react';
import type { RequirementsProps } from '@modules/dashboard/pages/docs-verification/docs-verification-page/requirements/types';
import { RequirementTypeEnum } from '@modules/dashboard/pages/docs-verification/docs-verification-page/requirements/types';
import { DocsVerificationRequirementsPage } from '@modules/widget/pages/docs-verification-requirements-page';
import { PoaRequirementsPage } from '@modules/widget/pages/poa-requirements-page';
import { SelfieRequirementsPage } from '@modules/widget/pages/selfie-requirements-page';

import { RequirementsContainer } from './styles';

export const Requirements: React.FC<RequirementsProps> = ({ onBack, type }) => (
    <RequirementsContainer className='requirements'>
        <div>
            {type === RequirementTypeEnum.PASSPORT && (
                <DocsVerificationRequirementsPage onBack={onBack} />
            )}
            {type === RequirementTypeEnum.SELFIE && <SelfieRequirementsPage onBack={onBack} />}
            {type === RequirementTypeEnum.POA && <PoaRequirementsPage onBack={onBack} />}
        </div>
    </RequirementsContainer>
);
